let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1qUWs"), load("9KJWc")]).then(() => parcelRequire('gVDaR'));